import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconSvg } from '@/lib/v2/components';
import { DragAndDropIcon, HtmlEditorIcon } from '@/lib/v2/icons/general';
import { InsightCardProps } from '@/lib/v2/organisms/InsightCard/InsightCard';

const ACTIONS_CARDS = 'CAMPAIGN_ACTIONS_MAIN.CREATE_EMAIL_ACTION.CARD_LIST';

export const useSendEmailCardList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const actionData = useAtomValue(atomActionData);

  const handleCardClick = useCallback(
    (route: string) => {
      if (route) navigate(route);
    },
    [navigate]
  );

  const cardList = useMemo<InsightCardProps[]>(
    () => [
      {
        icon: (
          <IconSvg
            height={'80px'}
            svgComponent={<DragAndDropIcon />}
            width={'80px'}
            withPadding="small"
          />
        ),
        description: t(`${ACTIONS_CARDS}.DRAG_AND_DROP.description`),
        title: t(`${ACTIONS_CARDS}.DRAG_AND_DROP.title`),
        isLoading: true,
        onClick: () => handleCardClick('editor'),
        id: 'drag-and-drop-card',
      },
      {
        icon: (
          <IconSvg
            height={'80px'}
            svgComponent={<HtmlEditorIcon />}
            width={'80px'}
            withPadding="small"
          />
        ),
        description: t(`${ACTIONS_CARDS}.HTML_EDITOR.description`),
        title: t(`${ACTIONS_CARDS}.HTML_EDITOR.title`),
        isLoading: true,
        onClick: () => handleCardClick('html-editor'),
        id: 'html-editor-card',
      },
    ],
    [t, handleCardClick]
  );

  return { cardList };
};
